import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { Button } from "../05-atoms/Button";
import { Icon, IconNames } from "../05-atoms/Icon";
/**
 *
 */
export var PaginationButtonComp = function (props) { return (React.createElement(Button, { link: { onClick: function (_e) { return props.changeThePage(props.targetPage); } }, disabled: props.disabled ? props.disabled : false }, props.children ? props.children : (React.createElement("span", { "aria-hidden": "true" }, props.targetPage + 1)))); };
/**
 *
 * @param props
 */
export var PaginationComp = function (props) {
    var className = joinClasses("scl-m-pagination", props.className, props.theme && props.theme.palette ? "scl-m-pagination--" + props.theme.palette : undefined);
    var maxPageNumber = props.pageCount - 1;
    var minPageNumber = 0;
    var changeThePage = function (newPage) {
        props.onPageChange(newPage);
    };
    var getPageItems = (React.createElement(React.Fragment, null,
        props.currentPage + 1 <= maxPageNumber ? null : (props.currentPage - 2 >= minPageNumber &&
            React.createElement("li", { className: "scl-m-pagination__item", key: props.currentPage - 2 },
                React.createElement(PaginationButtonComp, { targetPage: props.currentPage - 2, changeThePage: changeThePage }))),
        props.currentPage - 1 >= minPageNumber &&
            React.createElement("li", { className: "scl-m-pagination__item", key: props.currentPage - 1 },
                React.createElement(PaginationButtonComp, { targetPage: props.currentPage - 1, changeThePage: changeThePage })),
        React.createElement("li", { className: "scl-m-pagination__item active", key: props.currentPage },
            React.createElement(PaginationButtonComp, { targetPage: props.currentPage, changeThePage: changeThePage, disabled: true })),
        props.currentPage + 1 <= maxPageNumber &&
            React.createElement("li", { className: "scl-m-pagination__item", key: props.currentPage + 1 },
                React.createElement(PaginationButtonComp, { targetPage: props.currentPage + 1, changeThePage: changeThePage })),
        props.currentPage - 1 >= minPageNumber ? null : (props.currentPage + 2 <= maxPageNumber &&
            React.createElement("li", { className: "scl-m-pagination__item", key: props.currentPage + 2 },
                React.createElement(PaginationButtonComp, { targetPage: props.currentPage + 2, changeThePage: changeThePage })))));
    return (React.createElement("ul", { className: className },
        React.createElement("li", { className: "scl-m-pagination__item" },
            React.createElement(PaginationButtonComp, { targetPage: 0, changeThePage: changeThePage, disabled: !(props.currentPage > 0) },
                React.createElement(Icon, { name: IconNames.FIRST }))),
        React.createElement("li", { className: "scl-m-pagination__item scl-h-hidden--to-md" },
            React.createElement(PaginationButtonComp, { targetPage: props.currentPage - 1, changeThePage: changeThePage, disabled: !(props.currentPage > 0) },
                React.createElement(Icon, { name: IconNames.PREVIOUS }))),
        getPageItems,
        React.createElement("li", { className: "scl-m-pagination__item scl-h-hidden--to-md" },
            React.createElement(PaginationButtonComp, { targetPage: props.currentPage + 1, changeThePage: changeThePage, disabled: !(props.currentPage + 1 < props.pageCount) },
                React.createElement(Icon, { name: IconNames.NEXT }))),
        React.createElement("li", { className: "scl-m-pagination__item" },
            React.createElement(PaginationButtonComp, { targetPage: maxPageNumber, changeThePage: changeThePage, disabled: !(props.currentPage + 1 < props.pageCount) },
                React.createElement(Icon, { name: IconNames.LAST })))));
};
/**
 *
 */
export var Pagination = asThemeConsumer(PaginationComp);
